<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import Vue from "vue";
import VueResource from "vue-resource";

Vue.use(VueResource);

export default {
  name: "app"
};
</script>

<style lang="scss">
@import "assets/scss/global";
@import "assets/scss/var";
@import "assets/bootstrap/css/bootstrap.css";

#app {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  color: #fff;
  font-size: 16px;
  background-color: $page_background_color;
}
</style>



// WEBPACK FOOTER //
// src/App.vue